import React from 'react';
import { Button, Header, Icon, Loader, Popup, Responsive, Segment, Tab } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import NewExam from './NewExam';
import ExamsByCourseImpl from './ExamsByCourseImpl';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class ExamDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultActiveIndex: 1
        };
    }
    componentDidMount() {

    }
    handleTabChange = (e, { activeIndex }) => this.setState({ activeIndex })

    render() {
        const panes = [
            {
                menuItem: 'Kreiranje novog ispita',
                render: () => (<Tab.Pane as={Responsive}>
                    <NewExam
                        id={localStorage.getItem('id')}
                        name={localStorage.getItem('name')}
                        academicYearId={localStorage.getItem('academicYear')}
                        setActiveIndex={() => this.setState({ activeIndex: 1 })}
                    />


                </Tab.Pane>)
            },
            {
                menuItem: 'Prikaz ispita',
                render: () => (<Tab.Pane as={Responsive}>
                    <ExamsByCourseImpl
                        id={localStorage.getItem('id')}
                        name={localStorage.getItem('name')}
                    />

                </Tab.Pane>)
            }
        ];
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                <Header as="h1">{localStorage.getItem('thirdCycle') === 'true' ? 'Kreiranje i prikaz ispita' : localStorage.getItem('previous') === 'true' ? 'Prikaz ispita' : 'Kreiranje i prikaz ispita'}</Header>
                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">
                            { localStorage.getItem('name')}
                            {/*{(localStorage.getItem('comment'))==='null' ? '' : ' / ' + localStorage.getItem('comment')}*/}

                            <Header style={IconHeader} floated="right" >
                                <Icon />
                                <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic="true"
                                        floated="right"
                                        name="arrow left"
                                        onClick={() => { localStorage.setItem('returned', true); this.props.showExamDetails(false); }}
                                    />}
                                    content="Nazad"
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            <Header.Subheader floated="left">
                                {(localStorage.getItem('comment'))==='null' ? 'Predmet' : localStorage.getItem('comment')}
                                {/*{(localStorage.getItem('comment'))==='null' ? '' : ' / napomena' }*/}
                            </Header.Subheader>

                        </Header>
                    </Segment>
                    {(localStorage.getItem('thirdCycle') === 'true' || localStorage.getItem('specialist') === 'true') ?
                        <Segment clearing>
                            <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} defaultActiveIndex={this.state.defaultActiveIndex} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} />


                        </Segment>

                        : localStorage.getItem('previous') === 'true' ? <Segment clearing>
                            <ExamsByCourseImpl
                                id={localStorage.getItem('id')}
                                name={localStorage.getItem('name')}
                            />


                        </Segment> : <Segment clearing><Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} defaultActiveIndex={this.state.defaultActiveIndex} onTabChange={this.handleTabChange} activeIndex={this.state.activeIndex} /></Segment>
                    }

                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Exams/ExamDetails.js